import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE } from '../../shared/sociedadeSections';

const pedidoRegistroAtaConfig = {
  id: 'pedido_registro_ata',
  nome: 'Pedido de Registro de ATA',
  descricao: 'Solicitação de registro de ATA de sociedade',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'ata', tipoDocumentoProcesso: 541, name: 'ATA', description: 'ATA a ser registrada', required: true }
    ]
  },

  paymentConfig: {
    amount: 102.00
  },

  protocoloConfig: {
    modeloRequerimento: '274',
    tiposAssunto: '821',
    tipoPedido: '240'
  },

  dadosRequerimentoConfig: DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE,

  tituloConfig: {
    tipoLancamentoId: 143,
    enderecoOrigem: 'sociedadeSimples'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection()
      ]
    },
    enderecoSociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoRegistroAtaConfig;
